import { render, staticRenderFns } from "./fournisseurs.vue?vue&type=template&id=2f93ad86"
import script from "./fournisseurs.vue?vue&type=script&lang=js"
export * from "./fournisseurs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports